import React from 'react'
import { Pagination, Autoplay, Scrollbar, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import homePic1 from '../images/Banniere01.png'
import homePic2 from '../images/Banniere02.jpg'
import homePic3 from '../images/Banniere03.jpg'
import mission1 from '../images/homepart01.jpg'
import mission2 from '../images/homeminipart01.jpg'
import FactsCTA from './FactsCTA';
import { useLang } from "./Provider/LanguageProvider";
import useWindowSize from './utils/useWindowSize';
import checkDevice from './utils/checkDevice';

function Accueil(props) {
  const size = useWindowSize();
  const isMobile = checkDevice(size, 1000)
  const { language } = useLang();

  return (
    <div id='accueil'>
      <div className='gap-home'></div>
      <section className='section1'>
        <Swiper
          className='pic-cont'
          modules={[Pagination, Scrollbar, FreeMode, Autoplay]}
          slidesPerView='1'
          scrollbar={{
            draggable: true,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false
          }}
        >
          <SwiperSlide className='pic'>
            <img src={homePic1} alt='home background' />
          </SwiperSlide>
          {!isMobile?<SwiperSlide className='pic'>
            <img src={homePic2} alt='home background' />
          </SwiperSlide>:''}
          <SwiperSlide className='pic'>
            <img src={homePic3} alt='home background' />
          </SwiperSlide>
        </Swiper>
        <div className='welcome'>
          {language === 'fr' ? <span className='pre-title'>NOTRE PRINCIPE DE BASE EST</span> :
            <span className='pre-title'>OUR CORE PRINCIPLE IS</span>}
          {language === 'fr' ? <h1>LA CULTURE DE L’EXCELLENCE</h1> : <h1>THE CULTURE OF EXCELLENCE</h1>}

          {language === 'fr' ? <p>
            Maintenir des standards élevés dans notre gestion et dans nos opérations tout en respectant les normes
            réglementaires et éthiques du secteur. Mettre un point d’honneur à agir de manière responsable, transparente
            et à contribuer positivement à l'économie congolaise.
          </p> : <p>
            Maintaining high standards in our management and operations while complying with the regulatory
            and ethical standards of the industry. Taking pride in acting responsibly, transparently, and
            contributing positively to Congolese society.
          </p>}
          {language === 'fr' ? <a href='/notrentreprise'>
            NOTRE HISTOIRE →
          </a> : <a href='/notrentreprise'>
            OUR HISTORY →
          </a>}
        </div>
      </section>
      <section className='section2'>
        <div className='container'>
          <div className='left-cont' data-aos="fade-up-right">
            <img src={mission1} alt='mission' className='img1' />
            <img src={mission2} alt='mission' className='img2' />
          </div>
          {language === 'fr' ? <div className='right-cont' data-aos="fade-up-left">
            <div className='h3'>
              <div className='line'></div><h3>QUI SOMMES-NOUS?</h3>
            </div>
            <h2>NOUS CRÉONS DES
              OPPORTUNITÉS TOUT EN
              FAÇONNANT UN AVENIR
              MEILLEUR.</h2>
            <p>
              Depuis notre fondation en 1995, nous sommes devenus un acteur clé du
              secteur du tabac en République Démocratique du Congo, avec plus
              de 360 employés et une présence dans 17 provinces. Grâce à notre
              partenariat exclusif avec Japan Tobacco International (JTI), nous avons
              développé un réseau de distribution national robuste de cigarettes, avec
              plusieurs agences et entrepôts.
              <br />
              <br />
              Nous nous engageons à offrir des solutions responsables, en respectant
              les réglementations et en répondant aux besoins évolutifs de nos clients.
              Ensemble, nous contribuons à créer des expériences enrichissantes et à
              bâtir un avenir durable pour tous.
            </p>
            <div className='links'>
              <a href='/notrentreprise'>EN SAVOIR PLUS →</a>
              <a href='/nosmarques'>NOS MARQUES →</a>
            </div>
          </div> : <div className='right-cont' data-aos="fade-up-left">
            <div className='h3'>
              <div className='line'></div><h3>WHO ARE WE?</h3>
            </div>
            <h2>WE CREATE
              OPPORTUNITIES WHILE
              SHAPING A BETTER FUTURE.</h2>
            <p>
              Since our founding in 1995, we have become a key player in the tobacco industry
              in the Democratic Republic of Congo, with over 360 employees and a presence
              in 17 provinces. Thanks to our exclusive partnership with Japan Tobacco International (JTI),
              we have developed a robust national cigarette distribution network with several
              agencies and warehouses.
              <br />
              <br />
              We are committed to providing responsible solutions, adhering to regulations,
              and meeting the evolving needs of our customers. Together, we contribute to
              creating enriching experiences and building a sustainable future for all.
            </p>
            <div className='links'>
              <a href='/notrentreprise'>LEARN MORE →</a>
              <a href='/nosmarques'>OUR BRANDS →</a>
            </div>
          </div>}
        </div>
      </section>
      <section className='section3' >
        {language === 'fr' ? < div className='container' data-aos="zoom-in">
          <span className='pre-title'>NOUS ADOPTONS</span>
          <h1>UNE APPROCHE RESPONSABLE</h1>
          <p>
            Nous agissons de manière responsable et transparente dans notre approvisionnement
            de tabac et notre distribution dans toute la RDC.
          </p>
          <a href='/nosengagements'>
            NOS ENGAGMENTS →
          </a>
        </div> :
          <div className='container' data-aos="zoom-in">
            <span className='pre-title'>WE EMBRACE</span>
            <h1>A RESPONSIBLE APPROACH</h1>
            <p>
              We act responsibly and transparently in our tobacco sourcing and distribution
              throughout the DRC.
            </p>
            <a href='/nosengagements'>
              OUR COMMITMENTS →
            </a>
          </div>
        }
      </section>
      <FactsCTA />
    </div>
  )

}

export default Accueil